import { FC, memo } from 'react';

export interface SmallFadeSpinnerProps {
	size?: number;
	color?: string;
}

const animationName = 'SystemFadeSpinner';

export const SmallFadeSpinner: FC<SmallFadeSpinnerProps> = memo(props => ((
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 256 256'
		style={{
			width: props.size,
			height: props.size,
		}}
	>
		<rect width='256' height='256' fill='none'></rect>
		{smallSpinnerCoords.map((coords, index) => (
			<line
				key={index}
				x1={coords.x1}
				x2={coords.x2}
				y1={coords.y1}
				y2={coords.y2}
				fill='none'
				stroke={props.color}
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth={256 / 12}
				style={{
					animationFillMode: 'both',
					animation: `${animationName} 1.2s ${index * 0.12}s infinite ease-in-out`,
				}}
			></line>
		))}
	</svg>
)));

SmallFadeSpinner.displayName = 'SmallFadeSpinner';

const smallSpinnerCoords = [
	{
		x1: '128',
		x2: '128',
		y1: '32',
		y2: '64',
	},
	{
		x1: '195.882',
		x2: '173.255',
		y1: '60.118',
		y2: '82.745',
	},
	{
		x1: '224',
		x2: '192',
		y1: '128',
		y2: '128',
	},
	{
		x1: '195.882',
		x2: '173.255',
		y1: '195.882',
		y2: '173.255',
	},
	{
		x1: '128',
		x2: '128',
		y1: '224',
		y2: '192',
	},
	{
		x1: '60.118',
		x2: '82.745',
		y1: '195.882',
		y2: '173.255',
	},
	{
		x1: '32',
		x2: '64',
		y1: '128',
		y2: '128',
	},
	{
		x1: '60.118',
		x2: '82.745',
		y1: '60.118',
		y2: '82.745',
	},
];
